const CONTACT_API = {
	getIndexBanner:{
		url:'main/index/index',
		method:'get'
	},
	getIndexActives:{
		url:'sc/sh/newEvent',
		method:'get'
	},
	getIndexEssayRecommoned:{
		url:'search/recommendation/topping',
		method:'get'
	},
	getExpertRec:{
		url:'sc/sh/authorRecommend',
		method:'get'
	},
	getHotArticles:{
		url:'sc/sh/hotEssay',
		method:'get'
	},
	getTopics:{
		url:'con/question/getQuestionTopic',
		method:'get'
	},
	getArticleDetail:{
		url:'sc/sh/detailEssay',
		method:'get'
	},
	publishComment:{
		url:'sc/sh/publishComment',
		method:'post',
		noTrans:true
	},
	getComments:{
		url:'sc/sh/allDetailComment',
		method:'get'
	},
	commentPraise:{
		url:'sc/sh/setPraiseEvent',
		method:'get'
	},
	getUserInfo:{
		url:'main/register/userInfo',
		method:'get'
	},
	//获取考试系统菜单 以用来跳转
	getExamUserInfo:{
		url:'http://test.sozdata.com/exam/register/userInfo',
		method:'get'
	},
	//根据ip获取机构列表
	getIP:{
		url:'main/register/ipGroupList',
		method:'get'
	},
	deleteComment:{
		url:'sc/sh/delComment',
		method:'get'
	},
	getMoreReplies:{
		url:'sc/sh/childComment',
		method:'get'
	},
	getJubaoTypes:{
		url:'ja/lp/reportType',
		method:'get'
	},
	goJubao:{
		url:'ja/lp/report',
		method:'post',
		noTrans:true
	},
	articlePraise:{
		url:'sc/sh/setPraiseEvent',
		method:'get'
	},
	articleCollect:{
		url:'sc/sh/setCollectionEvent',
		method:'get'
	},
	articleShare:{
		url:'ja/lp/setShareNumber',
		method:'get'
	},
	getRecArticleById:{
		url:'sc/sh/relevantEssay',
		method:'post',
		noTrans:true
	},
	getViewList:{
		url:'sc/sh/essayList',
		method:'get'
	},
	foucsAuthor:{
		url:'ja/ei/follow',
		method:'get'
	},
	getPersonalInfo:{
		url:'main/person/info',
		method:'get'
	},
	getPersonalEssays:{
		url:'main/person/essays',
		method:'get'
	},
	getFuns:{
		url:'main/person/follow',
		method:'get'
	},
	deleteAuthor:{
		url:'main/person/dealFollow',
		method:'get',
		noTrans:true
	},
	isBingWechat:{
		url:'main/register/isBind',
		method:'get'
	},
	getSign:{
		url:'main/verify/getSign',
		method:'get'
	},
	getCode:{
		url:'main/verify/sendCode',
		method:'get'
	},
	affirmCode:{
		url:"main/verify/authCode",
		method:'get'
	},
	checkCode:{
		url:'main/register/verification',
		method:'get'
	},
	getNoticeType:{
		url:'main/person/getAllNoticType',
		method:'get'
	},
	setNoticeType:{
		url:'main/person/updateNoticType',
		method:'get'
	},
	changePrivateState:{
		url:'main/person/updateUserPrivacy',
		method:'post',
		noTrans:true
	},
	mobileIsExist:{
		url:'main/person/checkMobileExists',
		method:'post',
		noTrans:true
	},
	updateUserMobile:{
		url:'main/person/updateUserMobile',
		method:'post',
		noTrans:true
	},
	getBindWechatCode:{
		url:'main/login/sid',
		method:'get'
	},
	updateHeaderImg:{
		url:'main/person/updateImg',
		method:'post',
		noTrans:true
	},
	updateUserInfo:{
		url: 'main/person/updateInfo', //修改个人信息
        method: 'post',
		noTrans:true
	},
	login:{
		url:'main/register/registerUser',
		method:'post',
		noTrans:true
	},
	voteAnalysis:{
		url:'con/contribution/analysis',
		method:'post',
		noTrans:true
	},
	voteAnalysisInfo:{
		url:'con/contribution/analysisInfo',
		method:'post',
		noTrans:true
	},
	getRectEssay:{
		url:'search/recommendation/hot',
		method:'get'
	},
	searchArticle:{
		url:'search/essay/page',
		method:'post'
	},
	getEssayRec:{
		url:'search/article/page',
		method:'post',
		noTrans:true
	},
	getEssayExpertRec:{
		url:'search/recommendation/page',
		method:'post',
		noTrans:true
	},
	getInterestEssays:{
		url:'search/agg/tasteProceed',
		method:'post',
		noTrans:true
	},
	getInterestTopics:{
		url:'search/topic/tasteTheme',
		method:'post',
		noTrans:true
	},	
	getEssayCollections:{
		url:'search/agg/page',
		method:'post',
		noTrans:true
	},
	getCollectionDetail:{
		url:'search/agg/aggById',
		method:'post',
		noTrans:true
	},
	getEssayByCollection:{
		url:'search/agg/aggArticleListById',
		method:'post',
		noTrans:true
	},
	getLikeCollection:{
		url:'search/agg/moreLikeThis',
		method:'post',
		noTrans:true
	},
	getEsseyDetail:{
		url:'search/article/get',
		method:'get'
	},
	totalCount:{
		url:'search/common/agg',
		method:'post',
		noTrans:true
	},
	searchUser:{
		url:'search/pms/user/page',
		method:'post',
	},

	getUserCollections:{
		url:'main/person/aggs',
		method:'get'
	},
	//添加至论文集
	addCollection:{
		url:'search/agg/articleAggList',
		method:'get'
	},
	createCollection:{
		url:'ja/lp/addProceedings',
		method:'post'
	},
	searchTopics:{
		url:'sc/sh/selectTopic',
		method:'get'
	},
	addEssayToMyCollections:{
		url:'search/agg/addArticleAgg',
		method:'post',
		noTrans:true
	},
	collectEssay:{
		url:'search/agg/setCollectionEvent',
		method:'post',
		noTrans:true
	},
	getLikeThisEssay:{
		url:'search/article/moreLikeThis',
		method:'post'
	},
	getCollectionByEssyId:{
		url:'search/agg/includedAgg',
		method:'post',
		noTrans:true
	},
	scCollection:{
		url:'search/agg/setCollectionEvent',
		method:'post',
		noTrans:true
	},
	setEssayPraiseStatus:{
		url:'search/article/setPraiseEvent',
		method:'post',
		noTrans:true
	},
	setEssayPraiseStatus2:{
		url:'search/recommendation/setPraiseEvent',
		method:'post',
		noTrans:true
	},
	setEssayCollectStatus:{
		url:'search/article/setCollectionEvent',
		method:'post',
		noTrans:true
	},
	setEssayCollectStatus2:{
		url:'search/recommendation/setCollectionEvent',
		method:'post',
		noTrans:true
	},
	addViewArticle:{
		url:'sc/sh/addColumn',
		method:'post'
	},
	moveoutEssayFromCollection:{
		url:'search/agg/delArticleById',
		method:'post',
		noTrans:true
	},
	deleteEssayCollection:{
		url:'ja/lp/delProceedings',
		method:'get',
	},
	getUserPraises:{
		url:'main/person/praise',
		method:'get'
	},
	getUserCollection:{
		url:'main/person/collection',
		method:'get'
	},
	getRecConditions:{
		url:'search/recommendation/grouping',
		method:'get'
	},
	getHotTopic:{
		url:'sc/sh/hotTopic',
		method:'get'
	},
	getArticleByTopicId:{
		url:'sc/sh/contentByTopicId',
		method:'get'
	},
	getUserRanking:{
		url:'sc/sh/userRankById',
		method:'get'
	},
	getNotification:{//消息提醒
		url:'msg/notice/getList',
		method:'get'
	},
	//wechat login
	getWechatLoginSid: {
		url: 'main/login/sid',//微信登录或绑定所需的sid
		method: 'get',        
	},
	getActivityDetail:{
		url:'sc/column/goEvent',
		method:'get'
	},
	getActivityList:{
		url:'sc/column/recentNews',
		method:'get'
	},
	getTopicDetail:{
		url:'sc/sh/detailTopic',
		method:'get'
	},
	updateArticle:{
		url:'sc/sh/updateColumn',
		method:'post'
	},
	delArticle:{
		url:'sc/sh/delColumn',
		method:'get'
	},
	addTopic:{
		url:'sc/sh/addTopic',
		method:'get'
	},
	getExpertRecDetail:{
		url:'search/recommendation/get',
		method:'get'
	},
	//解绑轮询
	bindOrNot:{
		url:'main/register/bindOrNot',
		method:'get'
	},

	getIpGroups:{
		url:'exam/user/ipGroup',
		method:'get'
	},

	getOrgChildren:{
		url:'exam/expert/groupList',
		method:'get'
	},
	searchOrg:{
		url:'exam/user/getGroup',
		method:'get'
	},
	goPerfectOrg:{
		url:'exam/user/perfectInformation',
		method:'post',
	},
	getUserOrgInfo:{
		url:'exam/user/userInformation',
		method:'get'
	},
	getPersoanlUserGroupRole:{
		url:'user/userGroupRole',//查询机构与身份
		method:'get'
	},
	getUserIsAuth:{
		url:'exam/user/userGroupRole',
		method:'get'
	},

	//选题指南部分接口
	getRecKeywords:{
		url:'ja/tutorial/refkeywords',
		method:'post'
	},
	getRecTopics:{
		url:'ja/tutorial/recomTopics',
		method:'post'
	},
	getDocuments:{
		url:'ja/tutorial/generateArticlesAggs',
		method:'post'
	}
}
export default CONTACT_API;